import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API_URL, BRAND } from "../lib/brand";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API_URL}/admin/login`, { email, password });
      localStorage.setItem("tv_admin_token", data.access_token);
      toast.success("Accesso effettuato");
      navigate("/admin");
    } catch (err) {
      toast.error("Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <Link to="/" className="flex items-center gap-3 mb-10">
          <img src={BRAND.logo} alt="Logo" className="h-14 w-14 rounded-full" />
          <div>
            <p className="font-display text-2xl text-[#3D2140]">Teresa Vilardo</p>
            <p className="text-[10px] uppercase tracking-[0.3em] text-[#FF2768]">Admin</p>
          </div>
        </Link>

        <h1 className="font-display text-6xl text-[#3D2140] mb-3">Accedi</h1>
        <p className="text-[#3D2140]/60 mb-10">Gestisci il blog e le prenotazioni.</p>

        <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#81C3C9] mb-2 font-semibold">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email"
              className="w-full border-b-2 border-[#3D2140]/20 bg-transparent py-3 focus:border-[#FF2768] transition-colors text-lg outline-none"
            />
          </div>
          <div>
            <label className="block text-[10px] uppercase tracking-[0.3em] text-[#81C3C9] mb-2 font-semibold">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password"
              className="w-full border-b-2 border-[#3D2140]/20 bg-transparent py-3 focus:border-[#FF2768] transition-colors text-lg outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="btn-tv-primary w-full justify-center mt-4"
          >
            {loading ? "Attendi…" : "Entra"}
          </button>
        </form>
      </div>
    </div>
  );
}
